
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipment/[equipment]",
      function () {
        return require("private-next-pages/equipment/[equipment].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipment/[equipment]"])
      });
    }
  